import { EXPERIENCE, conferenceConfig as currentConferencePhase } from '@fs/zion-rootstech'

export const siteConfig = {
  experience: EXPERIENCE,
  conferencePreviewRedirects: currentConferencePhase.preview.redirects,
}

// Passed to zion's `Theme`/`Root` components to render RootsTech's brand colors instead of zion's defaults.
export const ROOTSTECH_BRAND = 'rootstech'
